import EventBus from 'diagram-js/lib/core/EventBus';
import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { PathwaysModeling } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import { connection, HEAD_NODE_ID, processType, subProcessType, taskType } from '@ispm-shared/modules/bpmn';
import { Base, Shape } from 'diagram-js/lib/model';
import { saveClear } from 'diagram-js/lib/util/Removal';
import { select, Store } from '@ngrx/store';
import { selectNodeCreationInfoById } from '@ispm-client/modules/bpmn-modeler/store/selectors';
import { map, take } from 'rxjs/operators';
import { map as lodashMap, without } from 'lodash';
import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { BpmnExtensionHelper } from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { PathwaysViewerCommands } from '@ispm/shared/bpmn-io/pathways-viewer-commands';

/**
 * Created By Elia Rohana on 6/5/19
 */

export class TreeRepair {

  constructor(private eventBus: EventBus, private modeling, private elementRegistry,
              private pathwaysModeling: PathwaysModeling, private store$: Store<State>,
              private bpmnExtensionHelper: BpmnExtensionHelper, private bpmnReplace, private pathwaysViewerCommands: PathwaysViewerCommands,
              private config: any) {
    this.eventBus.on(EventType.IMPORT_DONE, (event) => {
      const rootElement = this.elementRegistry.get(HEAD_NODE_ID);
      const performTreeRepairFlag = config.performTreeRepair === 'true' && localStorage.getItem('fixPathwayTree') === 'true';
      if (performTreeRepairFlag) {
        this.fixSubProcess(rootElement);
      }
    });
  }

  private fixSubProcess(root: Shape) {
    this.removeAllFloatingNodes();
    this.reCreateSubProcess(root);

  }

  private reCreateSubProcess(root: Shape) {
    if (root.type === subProcessType) {
      this.removeQuestions(root);
      this.removeChildren(root);
      this.pathwaysModeling.createSubProcessChildren(root);
      this.resetParentChildrenData(root);
    }
    const nodeType = ModelingUtil.getNodeType(root);
    if ((root.type === subProcessType || root.type === taskType) && nodeType !== NodeType.head && nodeType !== NodeType.treatment) {
      this.pathwaysModeling.clearConnectionConditionExpression(root.incoming[0]);
      this.getNodeData$([root.id]).subscribe(nodeCreationResultArray => {
        this.pathwaysModeling.createNodeData(root, nodeCreationResultArray[0], nodeType);
      });


    }
    this.fixNeighborhood_Head(nodeType, root);

    const outgoingConnections = root.outgoing;
    let target;
    for (const conn of outgoingConnections) {
      target = conn.target;
      this.reCreateSubProcess(target);
    }
  }

  private fixNeighborhood_Head(nodeType, target) {
    if (NodeType.neighborhood_head === nodeType && target.type === subProcessType) {
      if (target.outgoing && target.outgoing.length === 1) {
        const targetChildNode = target.outgoing[0].target;
        const targetChildNodeType = ModelingUtil.getNodeType(targetChildNode);
        if (NodeType.treatment === targetChildNodeType) {
          const targetNewType = { type: taskType};
          const newElement = this.bpmnReplace.replaceElement(target, targetNewType);
          this.pathwaysViewerCommands.setElementVisibility(newElement, true);

        }
      }
    }
  }

  private resetParentChildrenData(parentElement) {
    const childrenNodesIds = ModelingUtil.getDirectTreeChildrenNodesIds(parentElement);
    this.getNodeData$(childrenNodesIds)
      .subscribe(childrenDataArray => {
        this.pathwaysModeling.resetNodeChildrenData(parentElement, childrenDataArray);
      });
  }

  private getNodeData$(nodesIds: Array<string>) {
    return this.store$.pipe(select(selectNodeCreationInfoById(nodesIds)),
      map(nodeCreationInfoArray => without(lodashMap(nodeCreationInfoArray, 'data'), null, undefined)),
      take(1));
  }

  private removeAllFloatingNodes() {
    const elementsToRemove = this.elementRegistry.filter((element: Base) =>
      ModelingUtil.getElementType(element) !== connection && ModelingUtil.getElementType(element) !== processType && element.outgoing.length === 0 && element.incoming.length === 0);
    if (elementsToRemove && elementsToRemove.length > 0) {
      this.pathwaysModeling.removeElements(elementsToRemove);
    }
  }

  public removeChildren(parentElement: Shape) {
    // remove child shapes and connections
    saveClear(parentElement.children, (child) => {
      if (ModelingUtil.isConnection(child)) {
        this.pathwaysModeling.removeConnection(child, { nested: true});
      } else {
        this.modeling.removeShape(child, { nested: true});
      }
    });

  }

  private removeQuestions(parentElement) {
    const nodeDetails = ModelingUtil.getNodeDetails(parentElement);
    delete nodeDetails.questions;
    this.bpmnExtensionHelper.replaceExtension(parentElement, nodeDetails);
  }

}
